export default __webpack_public_path__ + "static/media/layout-1 (2).dc178f3b.jpg";